module.exports = __webpack_public_path__ + "img/hewi_3.2ffab3d7.jpg";